import { Marketplace } from '../types/Marketplace'
import ApiBase from './Api'

const MARKETPLACES_API_PATHS = {
    ALL_MARKETPLACES: '/marketplaces',
}

class MarketplacesApi extends ApiBase {
    async allMarketplaces(): Promise<Marketplace[]> {
        const response = await this._getRequest(MARKETPLACES_API_PATHS.ALL_MARKETPLACES)

        return response
    }
}

export default MarketplacesApi
